import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import PMProject from '../../components/projectmanager/new/Project/PMProject';
import { makeRandomString } from '../../utilities/Utility';
import moment from 'moment-timezone';

class PMProjectContainer extends Component {

	state = {
		currentItem: null,
		saved: true,
		newCommentLine: {
			uniqueID: '',
			author: '',
			createdBy: '',
			date: '',
			time: '',
			comment: ''
		},
	}

	componentWillMount() {
		this.retrieveAndFilter();
		this.retrieveComments();
		this.retrieveInvoice();
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.retrieveAndFilter();
			this.retrieveInvoice();
		}
	}

	retrieveAndFilter = () => {
		const p = this.props;

		let cur = p.reduxData.storedProjects[this.props.reduxData.currentProj];
		let filt = p.reduxData.storedPhases.filter(ph => ph.parentID === cur.uniqueID);

		let assignedUsers = p.reduxData.storedUsers.filter(isAssigned);

		this.setState({
			currentItem: cur,
			filteredPhases: filt,
			assignedUsers: assignedUsers
		})

		function isAssigned(usr) {
			let result = false;
			if (cur.assigned.includes(usr.uniqueID)) {
				result = true;
			}
			return result;
		}

	}

	retrieveComments = () => {
		const p = this.props;
		let cur = p.reduxData.storedProjects[p.reduxData.currentProj];
		p.getComments(cur.uniqueID);
	}

	retrieveInvoice = () => {
		const p = this.props;
		let cur = p.reduxData.storedProjects[p.reduxData.currentProj];
		if (cur.invoiceEntry && !p.reduxData.currentInvoice) {
			p.getInvoice(cur.invoiceEntry);
		} else {
			console.log("TODO no invoice, make one")
		}
	}

	componentFunctions = () => {
		var funcs = [];
		let obj = this;

		Object.getOwnPropertyNames(obj).forEach(function (property) {
			if (typeof obj[property] === 'function') {
				funcs[property] = obj[property];
			}
		});

		return funcs;
	}

	render() {
		return (
			<PMProject
				{...this.props}
				state={this.state}
				{...this.componentFunctions()}
			/>
		);
	}

	goBack = () => {
		const { setRoute, changeMode } = this.props;
		changeMode("bp", null);
		//setRoute('/projectmanager/');
	}

	toggleSaved = () => {
		this.props.updateProject(this.state.currentItem);
		this.setState({
			saved: true
		})
	}

	onChange = (value, attr) => {
		let newPhase = Object.assign({}, this.state.currentItem);
		newPhase[attr] = value;
		this.setState({
			currentItem: newPhase,
			saved: false
		})
	}

	addPhase = () => {
		let newPh = {
			uniqueID: makeRandomString(24),
			parentID: this.state.currentItem.uniqueID,
			display: " ... ",
			project: this.state.currentItem.display,
			bp: this.state.currentItem.bp,
			description: ' ... ',
			taskGroups: [],
			attachments: [],
			assigned: [],
			contacts: [],
			status: 'planned',
		}

		this.props.setAttributeByObj({
			overlayEditType: 'phase',
			temp: newPh
		});

		this.props.openOverlay('pmEdit');
	}

	addAssigned = (e) => {
		let newProj = Object.assign({}, this.state.currentItem);
		newProj.assigned = [...newProj.assigned, e.uniqueID];
		this.props.updateProject(newProj);
	}

	removeAssigned = (user) => {
		let newProj = Object.assign({}, this.state.currentItem);
		newProj.assigned = newProj.assigned.filter(usr => usr !== user.uniqueID);
		this.props.updateProject(newProj);
	}

	addAdditionalDetail = () => {
		const p = this.props;
		const { currentUser } = p.reduxData;

		let temp = Object.assign({}, this.state.newCommentLine);
		temp.parentID = this.state.currentItem.uniqueID;
		temp.uniqueID = makeRandomString(24);
		temp.createdBy = currentUser;
		//temp.author = getUserName(currentUser);
		temp.date = moment(new Date()).format('MM/DD/YYYY');
		temp.time = new moment().format("HH:mm A");

		p.saveComment(temp);

		this.setState({
			newCommentLine: {
				uniqueID: '',
				author: '',
				createdBy: '',
				date: '',
				time: '',
				comment: ''
			}
		})
	}

	onChangeAdditionalDetail = (value, returnObj) => {
		let newComment = Object.assign({}, this.state.newCommentLine);
		newComment[returnObj.attr] = value;
		this.setState({
			newCommentLine: newComment,
		})
	}

}

function mapStateToProps(state) {
	return {
		reduxData: state.pmData
	}
}

const mapDispatchToProps = dispatch => {
	return {
		setRoute: (route) => {
			dispatch(actions.routing.setRoute(route));
		},
		openOverlay: (obj) => {
			dispatch(actions.globalState.openOverlay(obj));
		},
		setAttributeByObj: (obj) => {
			dispatch(actions.pm.setAttributeByObj(obj));
		},
		updateProject: (obj) => {
			dispatch(actions.pm.updateProject(obj))
		},
		addPhase: (obj) => {
			dispatch(actions.pm.addPhase(obj))
		},
		getComments: (obj) => {
			dispatch(actions.pm.getComments(obj))
		},
		saveComment: (obj) => {
			dispatch(actions.pm.saveComment(obj))
		},
		updateComment: (obj) => {
			dispatch(actions.pm.updateComment(obj))
		},
		getInvoice: (obj) => {
			dispatch(actions.pm.getInvoice(obj))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PMProjectContainer);


// WEBPACK FOOTER //
// ./src/containers/projectmanager/PMProjectContainer.js